import React, { useEffect, useState } from 'react';
import { Translate }                  from 'react-localize-redux';
import styled, { withTheme }          from 'styled-components';

import Heading, { SubHeading } from '../../components/heading';
import ScriptLoader            from '../../components/script-loader';
import Section                 from './section';
import titleImg                from './images/title/News.png';

const TwitterContainer = styled.div`
  text-align: center;
`;

const BLANK = styled.div`
  margin-top: 2em;
`;

const Container = styled.div`
  padding: 1em;
`;

const News = ({ theme }) => {
  const [twttr, setTwttr] = useState(null);

  useEffect(() => {
    if (twttr && twttr.widgets) {
      twttr.widgets.load();
    }
  });

  return (
    <>
      <ScriptLoader
        id="twitter-wjs"
        onLoad={() => setTwttr(window.twttr)}
        src="https://platform.twitter.com/widgets.js"
      />
      <Container>

        <Section imgSrc={titleImg} titleWidth='100%'>
        <BLANK />

          <TwitterContainer key={theme.primary}>
            <blockquote className={"twitter-tweet"} data-theme="dark">
              <p lang="ja" dir="ltr">
                ＼🎊新作AR謎解きゲームのご案内🎊／
                <a href="https://twitter.com/hashtag/%E3%82%B3%E3%83%B3%E3%83%91%E3%82%B9AR%E8%AC%8E%E8%A7%A3%E3%81%8D?src=hash&amp;ref_src=twsrc%5Etfw">#コンパスAR謎解き</a>
                　MYSTERY OF MIRAGE MESSAGE<br/>
                10/28(水)〜開催 in 渋谷<br/>
                大人気スマホゲームとの夢のコラボ📱👾✨<br/>
                ヒーロー達と謎を解き明かし、ポータルを制圧📍🌪<br/>
                コレクションコンプリートで、ARヒーローを召喚🦸‍♂️✅<br/>
                <br/>
                👇予約受付中👇
                <a href="https://t.co/zkeLFyz7PE">https://t.co/zkeLFyz7PE</a>
              </p>
              &mdash; プレティアさん(AR謎解きアテンダント) (@ARpuzzle_)
              <a href="https://twitter.com/ARpuzzle_/status/1316198944632782849?ref_src=twsrc%5Etfw">October 14, 2020</a>
            </blockquote>
          </TwitterContainer>
        </Section>
      </Container>
    </>
  );
};

export default withTheme(News);
